import axios from 'axios';
import {router} from '../../../webstore-init.js';

export default {
    licensePurchaseRequest: ({ state, getters }) => {
        axios({
            method: 'POST',
            url: '/webstore/license-purchase-request',
            headers: {'Content-type': 'application/json'},
            data: {
                shoppingCart: state.productsInCart,
                vinData: getters.consolidatedVinData,
                mmyData: getters.consolidatedMmyData,
                manualSelectionData: getters.consolidatedManualSelectionData
            },
            timeout: 10000
        });
        try {
            mixpanel.track("Notify Sales Rep", {
                "page name": "Notify Sales Rep",
                "url": "/webstore/license-purchase-request"
            });
        } catch (e) {
            // pass
        }
        router.push({path: '/message', query: {type: 'licensePurchaseRequest'}});
        return;
    },

    productInquiryRequest: ({ state }, data) => {
        let response = axios({
            method: 'POST',
            url: '/webstore/product-inquiry-request',
            headers: {'Content-type': 'application/json'},
            data: {
                shoppingCart: state.productsInCart,
                product: data.product,
                message: data.message,
                email: data.email,
                name: data.name,
            },
            timeout: 10000
        });
        try {
            mixpanel.track("Notify Sales Rep - Product Inquiry", {
                "page name": "Notify Sales Rep - Product Inquiry",
                "url": "/webstore/product-inquiry-request"
            });
        } catch (e) {
            // pass
        }
        return response;
    },
}
